//import
import React, { useEffect, useState } from 'react';
import { Table, Space, Button, Pagination, Input } from 'antd';
import { GetAllGroups, GetAllLessons } from '../../../api/AdminService';
import { Link } from 'react-router-dom';
import LoadingPage from '../../../Components/LoadingPage/LoadingPage';
//item for Lesson
const titleStyle = { color: '#4A5568' };

const columns = [
  {
    title: <span style={titleStyle}>Group Name</span>,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: <span style={titleStyle}>Room Name</span>,
    dataIndex: 'room',
    key: 'room',
    render: (_, render) => (
      <Space size="middle">
        <div>{render.room.name}</div>
      </Space>
    ),
  },
  {
    title: <span style={titleStyle}>Monk</span>,
    dataIndex: 'monk',
    key: 'monk',
    render: (monk) => (
      monk === null ? <>Unassigned</> : <div>{monk.firstName} {monk.lastName}</div>
    ),
  },
  {
    title: <span style={titleStyle}>Action</span>,
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/Admin/Group/${record.id}`}>
          <Button type="primary">
            Detail
          </Button>
        </Link>
      </Space>
    ),
  },
]
const AdminGroup = () => {

  const [dataSrc, setDataSrc] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [loading, setLoading] = useState(true);
  const getGroups = (page) => {
    try {
      GetAllGroups(page).then(res => {
        if (res.status === 200) {
          console.log(res.data.data)
          setDataSrc(res.data.data)
          setTotalPage(res.data.pagination.totalRow)
          setLoading(false)
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getGroups(currentPage - 1);
  }, [currentPage]);

  return (
    <div
      style={{
        padding: 24,
        minHeight: '96.5vh',
        Width: '100vh',
      }}
    >
      <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>ALL GROUPS</h1>

      {loading ? (<LoadingPage />
      ) : (
        <>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
            <div>
              {/* <Button type="primary" href="/Admin/Lesson/AddLesson">
              Create Lesson
            </Button> */}

            </div>


            <Pagination
              current={currentPage}
              pageSize={12}
              total={totalPage}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>
          <Table columns={columns} dataSource={dataSrc} pagination={false} />
        </>)}
    </div>
  );
};

export default AdminGroup;
